const FileUploadLimit = new Map();

FileUploadLimit.set('loadingDocsLimit', 5);
FileUploadLimit.set('unloadingDocsLimit', 1);

export default FileUploadLimit;
